import React, { useCallback, memo, useMemo } from 'react';
import { withRouter } from 'react-router-dom';

import WebSalesOptions from 'components/auctions/AuctionVehicleCard/Footer/WebSalesOptions';
import VehicleDealerReceptorModality from 'components/shared/VehicleDealerReceptorModality';
import usePermissions from 'hooks/usePermissions';
import { READONLY_PERMISSION } from 'constants/Permissions';

const Footer = ({
    vehicle,
    disabledVehicleWebSalesButtons,
    history,
    countDownStatus,
    setLoading,
    loading,
    disableButtons,
    updateVehiclesList,
    type,
}) => {
    const { checkPermission } = usePermissions();
    const userIsAllowed = useMemo(() => !checkPermission(READONLY_PERMISSION), [
        checkPermission,
    ]);

    const printBuyOptions = useCallback(() => {
        const options = {
            type,
        };
        if (vehicle?.WebSalesId) {
            const disabledOptions =
                disabledVehicleWebSalesButtons ||
                countDownStatus !== 1 ||
                vehicle.Status > 2;
            return (
                <WebSalesOptions
                    history={history}
                    vehicle={vehicle}
                    options={options}
                    setLoadingParent={setLoading}
                    disableButtons={disableButtons}
                    updateVehiclesList={updateVehiclesList}
                    loading={loading}
                    disabled={!userIsAllowed || disabledOptions}
                />
            );
        } else if (vehicle?.RepurchaseObligation >= 0) {
            return (
                <div className="c-vehicle-buy-options u-1/1">
                    <VehicleDealerReceptorModality
                        history={history}
                        vehicleParent={vehicle}
                        loadingRequest={loading}
                        disabled={!userIsAllowed || loading}
                        options={options}
                    />
                </div>
            );
        }
    }, [
        type,
        vehicle,
        disabledVehicleWebSalesButtons,
        countDownStatus,
        history,
        setLoading,
        disableButtons,
        updateVehiclesList,
        loading,
        userIsAllowed,
    ]);
    return (
        <footer className="c-card__footer u-pt-none u-pb-none">
            {printBuyOptions()}
        </footer>
    );
};

export default memo(withRouter(Footer));
